import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthSimpleLayout from "../layouts/AuthSimpleLayout";
import ErrorLayout from "../layouts/ErrorLayout";
import MainLayout from "../layouts/MainLayout";

import Error404 from "components/errors/Error404";
import Error500 from "components/errors/Error500";

import SimpleForgetPassword from "components/authentication/simple/ForgetPassword";
import SimpleLogin from "components/authentication/simple/Login";
import SimplePasswordReset from "components/authentication/simple/PasswordReset";

import Dashboard from "components/dashboards/default";

import WizardAuth from "components/authentication/wizard/WizardAuth";
import ChartofAccountsTable from "components/modules/accounts/chart-of-accounts/ChartofAccountsTable";
import AddCostCenter from "components/modules/accounts/cost-center/add-cost-center/AddCostCenter";
import CostCenterTable from "components/modules/accounts/cost-center/CostCenterTable";
import AddFiscalYear from "components/modules/accounts/fiscal-year/add-fiscal-year/AddFiscalYear";
import FiscalYearTable from "components/modules/accounts/fiscal-year/FiscalYearTable";
import AddRole from "components/modules/administration-menu/RolesPermission/add-role-permission/AddRole";
import RolePermissionTable from "components/modules/administration-menu/RolesPermission/RolePermissionTable";
import AddUser from "components/modules/administration-menu/Users/add-user/AddUser";
import UsersTable from "components/modules/administration-menu/Users/UsersTable";
import CustomersTable from "components/modules/customers/CustomersTable";
import CustomerDetails from "components/modules/customers/details/CustomerDetails";
import CustomerEstimateDetails from "components/modules/customers/details/CustomerEstimateDetails";
import CustomerEstimatesTable from "components/modules/customers/details/CustomerEstimatesTable";
import EstimateDetail from "components/modules/estimates/details/EstimateDetail";
import EstimatesTable from "components/modules/estimates/EstimatesTable";
import CategoriesPage from "components/modules/libraries-menu/Categories/CategoriesPage";
import AddCategoryFieldSet from "components/modules/libraries-menu/CategoryFieldSets/add-category-fieldset/AddCategoryFieldSet";
import CategoryFieldSetsTable from "components/modules/libraries-menu/CategoryFieldSets/CategoryFieldSetsTable";
import AddCategoryGroup from "components/modules/libraries-menu/CategoryGroups/add-category-group/AddCategoryGroup";
import CategoryGroupsTable from "components/modules/libraries-menu/CategoryGroups/CategoryGroupsTable";
import AddCategoryVariants from "components/modules/libraries-menu/CategoryVariants/add-category-variants/AddCategoryVariants";
import CategoryVariantsTable from "components/modules/libraries-menu/CategoryVariants/CategoryVariantsTable";
import FieldSetsForm from "components/modules/libraries-menu/FieldSets/add-fieldset/FieldSetsForm";
import FieldSetTable from "components/modules/libraries-menu/FieldSets/FieldSetsTable";
import GetAnEstimate from "components/modules/libraries-menu/GetAnEstimate/GetAnEstimate";
import AddProduct from "components/modules/libraries-menu/Products/add-product/AddProduct";
import ProductsTable from "components/modules/libraries-menu/Products/ProductsTable";
import AddVariants from "components/modules/libraries-menu/Variants/add-variants/AddVariants";
import VariantsTable from "components/modules/libraries-menu/Variants/VariantsTable";
import AddPageGroup from "components/modules/page-group/add-page-group/AddPageGroup";
import PageGroupTable from "components/modules/page-group/PageGroupTable";
import AddPage from "components/modules/pages/add-page/AddPage";
import PagesTable from "components/modules/pages/PagesTable";
import GeneralDetail from "components/modules/setting/general/details/GeneralDetail";
import GeneralTable from "components/modules/setting/general/GeneralTable";
import AddSlider from "components/modules/slider/details/AddSlider";
import SliderTable from "components/modules/slider/SliderTable";
import Profile from "components/pages/user/profile/Profile";
import Wizard from "components/wizard/Wizard";
import { ChartOfAccountsContextProvider } from "context/ChartOfAccountContext";
import { FiscalYearContextProvider } from "context/FiscalYearContext";
import AuthGuard from "./Gaurd/AuthGaurd";

import AddFinanceBook from "components/modules/accounts/finance-books/add-finance-book/AddFinanceBook";
import FinanceBooksTable from "components/modules/accounts/finance-books/FinanceBooksTable";
import BatchPostingTable from "components/modules/accounts/voucher/batch-posting/BatchPostingTable";
import AddVoucher from "components/modules/accounts/voucher/entries/add-voucher/AddVoucher";
import VoucherPrint from "components/modules/accounts/voucher/entries/add-voucher/VoucherPrint";
import VouchersTable from "components/modules/accounts/voucher/entries/VouchersTable";
import AccountPayableReport from "components/modules/reporting/account-payable/AccountPayableReport";
import AccountReceivableReport from "components/modules/reporting/account-receivable/AccountReceivableReport";
import BalanceSheetReport from "components/modules/reporting/balance-sheet/BalanceSheetReport";
import CashFlowReport from "components/modules/reporting/cash-flow/CashFlowReport";
import GeneralLedgerReport from "components/modules/reporting/general-ledger/GeneralLedgerReport";
import ProfitAndLossReport from "components/modules/reporting/profit-loss/ProfitAndLossReport";
import TrialBalanceReport from "components/modules/reporting/trial-balance/TrialBalanceReport";
import VoucherExample from "components/modules/reporting/voucher-example/VoucherExample";
import VoucherReport from "components/modules/reporting/vouchers/VoucherResport";
import { SettingsContextProvider } from "context/SettingContext";
import CompaniesTable from "modules/super_administration/companies/CompaniesTable";
import AddCompany from "modules/super_administration/companies/add-company/AddCompany";
import AddWeighmentEntry from "modules/weighments/weightment_entry/add-entry/AddWeighmentEntry";
import WeighmentEntryTable from "modules/weighments/weightment_entry/WeighmentEntryTable";
import IndicatorsTable from "modules/libraries/indicators/IndicatorsTable";
import AddIndicator from "modules/libraries/indicators/add-indicator/AddIndicator";
import SiteTable from "modules/libraries/site/SiteTable";
import AddSite from "modules/libraries/site/add-site/AddSite";
export const CONSTANT_ROUTES = {
  AUTHENTICATION_LOGIN: "/login",
  AUTHENTICATION_REGISTER: "/register",
  AUTHENTICATION_RESET_PASSWORD: "/reset-password",
  AUTHENTICATION_FORGOT_PASSWORD: "/forgot-password",
  USERPROFILE: "/userProfile",
  HOME: "/",
  CATEGORIES_PAGE: "/libraries/categories",
  CATEGORY_GROUPS_PAGE: "/libraries/category-groups",
  CATEGORY_GROUPS_ADD: "/libraries/category-groups/add-new",
  FIELD_SETS_TABLE: "/libraries/fieldSets",
  FIELD_SETS_ADD: "/libraries/fieldSets/add-new",
  CATEGORY_FIELDSET_TABLE: "/libraries/category-fieldset",
  CATEGORY_FIELDSET_ADD: "/libraries/category-fieldset/add-new",
  CATEGORY_VARIANTS_TABLE: "/libraries/category-variants",
  CATEGORY_VARIANTS_ADD: "/libraries/category-variants/add-new",
  PRODUCTS_TABLE: "/libraries/products",
  PRODUCTS_ADD: "/libraries/products/add-new",
  VARIANTS_TABLE: "/libraries/variants",
  VARIANTS_ADD: "/libraries/variants/add-new",
  PAGES_TABLE: "/pages",
  PAGES_ADD: "/pages/add-new",
  PAGE_GROUPS_TABLE: "/page-groups",
  PAGE_GROUP_ADD: "/page-groups/add-new",
  CUSTOMERS_TABLE: "/customers",
  CUSTOMER_TABLE_DETAIL: "/customers/detail",
  ESTIMATES_TABLE: "/estimates",
  ESTIMATES_TABLE_DETAILS: "/estimates/detail",
  CUSTOMER_ESTIMATE_TABLE: "/customer-estimates",
  CUSTOMER_ESTIMATE_DETAILS: "/customer-estimates/detail",

  USERS_TABLE: "/administration/users",
  USER_ADD: "/administration/users/add-new",

  ROLE_PERMISSION_TABLE: "/administration/roles",
  ROLES_PERMISSION_ADD: "/administration/roles/add-new",

  SETTING_GENERAL: "/settings/general",
  SETTING_GENERAL_UPDATE: "/settings/general/update",

  SLIDER_TABLE: "/slider",
  SLIDER_UPDATE: "/slider/add-new",

  COST_CENTER: "/accounts/cost-center",
  COST_CENTER_ADD: "/accounts/cost-center/add-new",

  FISCAL_YEAR: "/accounts/fiscal-year",
  FISCAL_YEAR_ADD: "/accounts/fiscal-year/add-new",
  FISCAL_PERIOD_ADD: "/accounts/fiscal-period/add-new",

  FINANCE_BOOKS: "/accounts/finance-books",
  FINANCE_BOOK_ADD: "/accounts/finance-books/add-new",

  VOUCHERS: "/accounts/vouchers",
  VOUCHER_ADD: "/accounts/vouchers/add-new",
  BATCH_POSTING: "/accounts/posting",
  VOUCHER_PRINT: "/accounts/vouchers/print",

  CHART_OF_ACCOUNTS_TABLE: "/accounts/chart-of-accounts",

  COMPANIES_TABLE: "/company",
  COMPANY_ADD: "/company/add-new",
  WEIGHMENTS_TABLE: "/weighment",
  WEIGHMENT_ADD: "/weighment/add-new",
  INDICATORS_TABLE: "/libraries/weighment-indicators",
  INDICATOR_ADD: "/libraries/weighment-indicators/add-new",
  SITE_TABLE: "/libraries/weighment-sites",
  SITE_ADD: "/libraries/weighment-sites/add-new",

  // Reports
  VOUCHER_REPORT: "/accounts/reports/voucher",
  GENERAL_LEDGER_REPORT: "/accounts/reports/ledger",
  TRIAL_BALANCE_REPORT: "/accounts/reports/trialbalance",
  BALANCE_SHEET_REPORT: "/accounts/reports/balancesheet",
  PROFIT_LOSS_REPORT: "/accounts/reports/profitloss",
  ACCOUNTS_RECEIVABLE_REPORT: "/accounts/reports/receivable",
  ACCOUNTS_PAYABLE_REPORT: "/accounts/reports/payable",
  CASH_FLOW_REPORT: "/accounts/reports/cashflow",
};

const FalconRoutes = () => {
  return (
    <Routes>
      {/* <Route path="landing" element={<Landing />} /> */}
      <Route element={<ErrorLayout />}>
        <Route path="errors/404" element={<Error404 />} />
        <Route path="errors/500" element={<Error500 />} />
      </Route>
      {/*- ------------- Authentication ---------------------------  */}

      {/*- ------------- simple ---------------------------  */}
      <Route element={<AuthSimpleLayout />}>
        <Route
          path={CONSTANT_ROUTES.AUTHENTICATION_LOGIN}
          element={<SimpleLogin />}
        />
        {/* <Route
          path="authentication/register"
          element={<SimpleRegistration />}
        /> */}
        <Route
          path={CONSTANT_ROUTES.AUTHENTICATION_FORGOT_PASSWORD}
          element={<SimpleForgetPassword />}
        />

        {/* <Route
          path="authentication/lock-screen"
          element={<SimpleLockScreen />}
        />
        <Route path="authentication/logout" element={<SimpleLogout />} />
       
   
        <Route
          path="authentication/confirm-mail"
          element={<SimpleConfirmMail />}
        /> */}
      </Route>

      {/* //--- MainLayout Starts  */}

      <Route element={<AuthGuard />}>
        <Route
          element={
            <SettingsContextProvider>
              <MainLayout />
            </SettingsContextProvider>
          }
        >
          <Route
            path={CONSTANT_ROUTES.AUTHENTICATION_RESET_PASSWORD}
            element={<SimplePasswordReset />}
          />
          {/*Dashboard*/}
          <Route path="/" element={<Dashboard />} />

          {/* =============Libraries=============== */}
          {/* <Route path="/libraries/categories" element={<CategoriesTable />} />
          <Route
            path="/libraries/categories/add-new-category"
            element={<AddCategory />}
          /> */}
          <Route
            path={CONSTANT_ROUTES.CATEGORIES_PAGE}
            element={<CategoriesPage />}
          />
          <Route
            path={CONSTANT_ROUTES.CATEGORY_GROUPS_PAGE}
            element={<CategoryGroupsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.CATEGORY_GROUPS_ADD}
            element={<AddCategoryGroup />}
          />
          <Route
            path={CONSTANT_ROUTES.FIELD_SETS_TABLE}
            element={<FieldSetTable />}
          />
          <Route
            path={CONSTANT_ROUTES.FIELD_SETS_ADD}
            element={<FieldSetsForm />}
          />
          <Route
            path={CONSTANT_ROUTES.CATEGORY_FIELDSET_TABLE}
            element={<CategoryFieldSetsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.CATEGORY_FIELDSET_ADD}
            element={<AddCategoryFieldSet />}
          />
          <Route
            path={CONSTANT_ROUTES.CATEGORY_VARIANTS_TABLE}
            element={<CategoryVariantsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.CATEGORY_VARIANTS_ADD}
            element={<AddCategoryVariants />}
          />
          <Route
            path={CONSTANT_ROUTES.VARIANTS_TABLE}
            element={<VariantsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.VARIANTS_ADD}
            element={<AddVariants />}
          />
          <Route
            path={CONSTANT_ROUTES.PRODUCTS_TABLE}
            element={<ProductsTable />}
          />
          <Route path={CONSTANT_ROUTES.PRODUCTS_ADD} element={<AddProduct />} />
          <Route path={CONSTANT_ROUTES.PAGES_ADD} element={<AddPage />} />
          <Route path={CONSTANT_ROUTES.PAGES_TABLE} element={<PagesTable />} />
          <Route
            path={CONSTANT_ROUTES.PAGE_GROUPS_TABLE}
            element={<PageGroupTable />}
          />
          <Route
            path={CONSTANT_ROUTES.PAGE_GROUP_ADD}
            element={<AddPageGroup />}
          />
          <Route
            path={CONSTANT_ROUTES.SLIDER_TABLE}
            element={<SliderTable />}
          />
          <Route path={CONSTANT_ROUTES.SLIDER_UPDATE} element={<AddSlider />} />
          <Route
            path={CONSTANT_ROUTES.ESTIMATES_TABLE}
            element={<EstimatesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ESTIMATES_TABLE_DETAILS}
            element={<EstimateDetail />}
          />
          <Route
            path={CONSTANT_ROUTES.CUSTOMERS_TABLE}
            element={<CustomersTable />}
          />
          <Route
            path={CONSTANT_ROUTES.CUSTOMER_TABLE_DETAIL}
            element={<CustomerDetails />}
          />
          <Route
            path={CONSTANT_ROUTES.CUSTOMER_ESTIMATE_TABLE}
            element={<CustomerEstimatesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.CUSTOMER_ESTIMATE_DETAILS}
            element={<CustomerEstimateDetails />}
          />
          <Route
            path={CONSTANT_ROUTES.SETTING_GENERAL}
            element={<GeneralTable />}
          />
          <Route
            path={CONSTANT_ROUTES.SETTING_GENERAL_UPDATE}
            element={<GeneralDetail />}
          />

          <Route
            path={CONSTANT_ROUTES.COST_CENTER}
            element={<CostCenterTable />}
          />
          <Route
            path={CONSTANT_ROUTES.COST_CENTER_ADD}
            element={<AddCostCenter />}
          />

          <Route
            path={CONSTANT_ROUTES.FISCAL_YEAR}
            element={
              <FiscalYearContextProvider>
                <FiscalYearTable />
              </FiscalYearContextProvider>
            }
          />
          <Route
            path={CONSTANT_ROUTES.FISCAL_YEAR_ADD}
            element={
              <FiscalYearContextProvider>
                <AddFiscalYear />
              </FiscalYearContextProvider>
            }
          />
          {/* <Route
            path={CONSTANT_ROUTES.FISCAL_PERIOD_ADD}
            element={
              // <FiscalYearContextProvider>
              <AddFiscalPeriod />
              // </FiscalYearContextProvider>
            }
          /> */}
          <Route
            path={CONSTANT_ROUTES.FINANCE_BOOKS}
            element={<FinanceBooksTable />}
          />
          <Route
            path={CONSTANT_ROUTES.FINANCE_BOOK_ADD}
            element={<AddFinanceBook />}
          />
          <Route path={CONSTANT_ROUTES.VOUCHERS} element={<VouchersTable />} />
          <Route path={CONSTANT_ROUTES.VOUCHER_ADD} element={<AddVoucher />} />
          <Route
            path={CONSTANT_ROUTES.BATCH_POSTING}
            element={<BatchPostingTable />}
          />
          <Route
            path={CONSTANT_ROUTES.VOUCHER_PRINT}
            element={<VoucherPrint />}
          />

          <Route
            path={CONSTANT_ROUTES.CHART_OF_ACCOUNTS_TABLE}
            element={
              <ChartOfAccountsContextProvider>
                <ChartofAccountsTable />
              </ChartOfAccountsContextProvider>
            }
          />

          {/* ============================Reporting============================ */}

          <Route
            path={CONSTANT_ROUTES.VOUCHER_REPORT}
            element={<VoucherReport />}
          />
          <Route
            path={CONSTANT_ROUTES.GENERAL_LEDGER_REPORT}
            element={<GeneralLedgerReport />}
          />
          <Route
            path={CONSTANT_ROUTES.TRIAL_BALANCE_REPORT}
            element={<TrialBalanceReport />}
          />
          <Route
            path={CONSTANT_ROUTES.BALANCE_SHEET_REPORT}
            element={<BalanceSheetReport />}
          />
          <Route
            path={CONSTANT_ROUTES.PROFIT_LOSS_REPORT}
            element={<ProfitAndLossReport />}
          />
          <Route
            path={CONSTANT_ROUTES.ACCOUNTS_RECEIVABLE_REPORT}
            element={<AccountReceivableReport />}
          />
          <Route
            path={CONSTANT_ROUTES.ACCOUNTS_PAYABLE_REPORT}
            element={<AccountPayableReport />}
          />
          <Route
            path={CONSTANT_ROUTES.CASH_FLOW_REPORT}
            element={<CashFlowReport />}
          />

          {/* <Route path={CONSTANT_ROUTES.PRODUCTS_ADD} element={<AddProduct />} /> */}

          {/* ===============Libraries End================ */}

          {/*============================Administration=========================  */}

          {/* <Route path="/groups" element={<GroupsTable />} />
          <Route path="/groups/add-new-group" element={<AddGroup />} /> */}
          {/* <Route
            path="/administration/roles-and-permissions"
            element={<RolesAndPermissionsTable />}
          />
          <Route
            path="/administration/roles-and-permissions/add-new-role"
            element={<AddRoleAndPermission />}
          />
          <Route
            path="/administration/roles-and-permissions/assignment"
            element={<AddAssignment />}
          /> */}
          <Route
            path={CONSTANT_ROUTES.ROLE_PERMISSION_TABLE}
            element={<RolePermissionTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ROLES_PERMISSION_ADD}
            element={<AddRole />}
          />
          <Route path={CONSTANT_ROUTES.USERS_TABLE} element={<UsersTable />} />
          <Route path={CONSTANT_ROUTES.USER_ADD} element={<AddUser />} />
          {/* <Route path="/infinite-scroll" element={<AgGridInfiniteScroll />} />
          <Route path="/map" element={<GoogleMapExample />} /> */}

          {/*============================Administration End=========================  */}
          {/*============================Super Administration=========================  */}

          <Route
            path={CONSTANT_ROUTES.COMPANIES_TABLE}
            element={<CompaniesTable />}
          />
          <Route path={CONSTANT_ROUTES.COMPANY_ADD} element={<AddCompany />} />
          <Route
            path={CONSTANT_ROUTES.WEIGHMENTS_TABLE}
            element={<WeighmentEntryTable />}
          />
          <Route
            path={CONSTANT_ROUTES.WEIGHMENT_ADD}
            element={<AddWeighmentEntry />}
          />
          <Route
            path={CONSTANT_ROUTES.INDICATORS_TABLE}
            element={<IndicatorsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.INDICATOR_ADD}
            element={<AddIndicator />}
          />
          <Route path={CONSTANT_ROUTES.SITE_TABLE} element={<SiteTable />} />
          <Route path={CONSTANT_ROUTES.SITE_ADD} element={<AddSite />} />

          {/*============================Super Administration End=========================  */}

          {/*=======Pages  ======*/}

          <Route path={CONSTANT_ROUTES.USERPROFILE} element={<Profile />} />
          {/* <Route path={"/calender"} element={<Calendar />} />
          <Route path={"/timeline"} element={<Timeline />} />
          <Route path={"/tree-view"} element={<TreeViewFalconExample />} />
          <Route path={"/dynamic-form"} element={<DynamicForm />} />
          <Route path={"/dnd-example"} element={<DndExampleComponent />} /> */}
          <Route element={<WizardAuth />}>
            <Route path="/home/wizard" element={<Wizard validation={true} />} />
            <Route
              path="/home/get-an-estimate"
              element={<GetAnEstimate validation={true} />}
            />
          </Route>
        </Route>
      </Route>

      {/* <Route path="/example" element={<SunTextEditor />} /> */}
      <Route path="/example" element={<VoucherExample />} />

      {/* //--- MainLayout end  */}

      {/* <Navigate to="/errors/404" /> */}
      <Route path="*" element={<Navigate to="/errors/404" replace />} />
    </Routes>
  );
};

export default FalconRoutes;
